import { render, staticRenderFns } from "./ReceptionDeliveryEditor.vue?vue&type=template&id=fbedefb6&scoped=true&"
import script from "./ReceptionDeliveryEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDeliveryEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDeliveryEditor.vue?vue&type=style&index=0&id=fbedefb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbedefb6",
  null
  
)

export default component.exports